// Read-aloud equations via the Web Speech API.
const supported = typeof window !== "undefined" && "speechSynthesis" in window;

export const speech = {
  supported,
  speak(text) {
    if (!supported) return;
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.rate = 0.95;
    u.pitch = 1.15;
    u.volume = 1;
    window.speechSynthesis.speak(u);
  },
  speakEquation(a, b) {
    this.speak(`${a} times ${b}`);
  },
  speakAnswer(a, b, product) {
    this.speak(`${a} times ${b} equals ${product}`);
  },
  cancel() {
    if (supported) window.speechSynthesis.cancel();
  },
};
